import SlideBanner from "./SlideBanner";
function BannerHome() {
  return (
    <div className="bannerHome">
      <SlideBanner />
    </div>
  );
}
export default BannerHome;
